/**
 * @fileoverview แปลข้อความที่ backend ส่งมา (อังกฤษ) เป็นภาษาที่ผู้ใช้เลือก ตอนแสดงผลเท่านั้น
 * ไม่แก้ค่า result.message จึงไม่กระทบโค้ดที่เทียบข้อความ เช่น 'Token not found'
 * ข้อความที่ไม่รู้จักจะคืนค่าเดิม — เพิ่มข้อความใหม่ได้ที่ MESSAGE_TH / PATTERN_TH
 * (ที่มา: config/global_message.js ของ backend + ข้อความ hardcode ใน auth/response/validator)
 * @module utils/backendMessage
 */

import th from '../components/language/th.json';
import en from '../components/language/en.json';

/** ล้าง localStorage (ออกจากระบบ/token หมดอายุ) แต่คงภาษาที่ผู้ใช้เลือกไว้ */
export const clearStorageKeepLang = () => {
  const lang = localStorage.getItem('lang');
  localStorage.clear();
  if (lang) localStorage.setItem('lang', lang);
};

const currentLang = () => (localStorage.getItem('lang') === 'EN' ? 'EN' : 'TH');

/** แปลคีย์ UI (ปุ่ม/หัวข้อ) ตามภาษาปัจจุบัน — logic เดียวกับ t() ใน CustomComponent (ไม่ import ตรงเพื่อกัน circular) */
export const uiText = (key) => {
  const dict = currentLang() === 'EN' ? en : th;
  return dict[key] || key;
};

// ข้อความตายตัว (ตรงทั้งประโยค)
const MESSAGE_TH = {
  // ทั่วไป
  'Success': 'ทำรายการสำเร็จ',
  'Error': 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
  'An error occurred.': 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
  'Something went wrong': 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
  'Internal Server Error': 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้งภายหลัง',
  'Inernal Server Error': 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้งภายหลัง',
  'Service Unavailable': 'ระบบยังไม่พร้อมใช้งาน กรุณาลองใหม่อีกครั้งภายหลัง',
  'Validation failed': 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแล้วลองใหม่',
  'Invalid request data': 'ข้อมูลที่ส่งไม่ถูกต้อง',
  'Invalid request body': 'ข้อมูลที่ส่งไม่ถูกต้อง',
  'Too many requests, please try again later': 'ทำรายการบ่อยเกินไป กรุณารอสักครู่แล้วลองใหม่',
  'Too many requests for this asset, please try again later': 'ทำรายการบ่อยเกินไป กรุณารอสักครู่แล้วลองใหม่',
  'The transaction was completed successfully.': 'ทำรายการสำเร็จ',
  'Logged out successfully': 'ออกจากระบบเรียบร้อยแล้ว',
  'Password changed successfully': 'เปลี่ยนรหัสผ่านสำเร็จ',
  'File uploaded successfully': 'อัปโหลดไฟล์สำเร็จ',
  'Presigned URL generated successfully': 'เตรียมอัปโหลดไฟล์สำเร็จ',
  'upload failed': 'อัปโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  'No file': 'ไม่พบไฟล์',
  'Copied successfully': 'คัดลอกแล้ว',
  'fetch is not defined': 'ไม่พบข้อมูล',
  // เข้าสู่ระบบ / token / สิทธิ์
  'Login failed, please check your credentials': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
  'Invalid credentials or inactive account': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง หรือบัญชีถูกปิดใช้งาน',
  'User not found': 'ไม่พบผู้ใช้นี้ในระบบ',
  'Email not found': 'ไม่พบอีเมลนี้ในระบบ',
  'Password not found': 'บัญชีนี้ยังไม่ได้ตั้งรหัสผ่าน กรุณาติดต่อผู้ดูแลระบบ',
  'Incorrect password': 'รหัสผ่านไม่ถูกต้อง',
  'Token not found': 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่',
  'Token has expired': 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่',
  'Token is required': 'กรุณาเข้าสู่ระบบก่อนใช้งาน',
  'Token verification failed, please try again': 'ตรวจสอบสิทธิ์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  'Signed in from another device': 'บัญชีนี้ถูกเข้าสู่ระบบจากอุปกรณ์อื่น กรุณาเข้าสู่ระบบใหม่',
  'Authorization header missing': 'กรุณาเข้าสู่ระบบก่อนใช้งาน',
  'Invalid authentication format': 'ข้อมูลการเข้าสู่ระบบไม่ถูกต้อง กรุณาเข้าสู่ระบบใหม่',
  'Invalid format for required header key': 'ข้อมูลที่ส่งไม่ถูกต้อง กรุณาเข้าสู่ระบบใหม่',
  'Invalid format for required key': 'ข้อมูลที่ส่งไม่ถูกต้อง กรุณาเข้าสู่ระบบใหม่',
  'Missing required header key': 'ข้อมูลที่ส่งไม่ครบ กรุณาเข้าสู่ระบบใหม่',
  'Invalid environment configuration': 'การตั้งค่าระบบไม่ถูกต้อง กรุณาติดต่อผู้ดูแลระบบ',
  'User account is deactivated': 'บัญชีนี้ถูกปิดใช้งาน กรุณาติดต่อผู้ดูแลระบบ',
  'User not verified, please verify your account first': 'บัญชียังไม่ได้ยืนยันตัวตน กรุณายืนยันบัญชีก่อน',
  'User is verified': 'ยืนยันตัวตนเรียบร้อยแล้ว',
  'Access denied': 'คุณไม่มีสิทธิ์ทำรายการนี้ กรุณาติดต่อผู้ดูแลระบบ',
  'Password change required': 'กรุณาเปลี่ยนรหัสผ่านก่อนใช้งาน',
  'New password must be at least 6 characters': 'รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร',
  'invalid email format': 'รูปแบบอีเมลไม่ถูกต้อง',
  'This user type has view-only access on this portal': 'ผู้ใช้ประเภทนี้ดูข้อมูลได้อย่างเดียวในส่วนนี้',
  'Selected supervisor\'s user type cannot be a supervisor': 'ประเภทผู้ใช้ที่เลือกเป็นหัวหน้างานไม่ได้',
  'Selected approver\'s user type is not allowed for this user type': 'ประเภทผู้ใช้ที่เลือกเป็นผู้อนุมัติของผู้ใช้ประเภทนี้ไม่ได้',
  'Cannot select yourself or your own subordinate as a supervisor': 'ไม่สามารถเลือกตัวเองหรือลูกทีมของตัวเองเป็นหัวหน้างานได้',
  'Cannot select yourself as supervisor level 2': 'ไม่สามารถเลือกตัวเองเป็นหัวหน้างานระดับ 2 ได้',
  'Supervisor level 2 must be different from supervisor level 1': 'หัวหน้างานระดับ 2 ต้องไม่ซ้ำกับระดับ 1',
  'Supervisor level 1 is required before selecting supervisor level 2': 'กรุณาเลือกหัวหน้างานระดับ 1 ก่อนเลือกระดับ 2',
  'This email is already used by another account in the system': 'อีเมลนี้ถูกใช้โดยบัญชีอื่นในระบบแล้ว',
  // ไม่พบข้อมูล
  'Data not found': 'ไม่พบข้อมูล',
  'Data Not found': 'ไม่พบข้อมูล',
  'Role data not found': 'ไม่พบข้อมูลบทบาท',
  'User data not found': 'ไม่พบข้อมูลผู้ใช้',
  'Company data not found': 'ไม่พบข้อมูลบริษัท',
  'Customer data not found': 'ไม่พบข้อมูลลูกค้า',
  'API route not found': 'ไม่พบบริการที่เรียกใช้',
  // ซ้ำ / ถูกใช้งานอยู่
  'This name already exists': 'ชื่อนี้มีอยู่ในระบบแล้ว',
  'This email already exists': 'อีเมลนี้มีอยู่ในระบบแล้ว',
  'This role name already exists': 'ชื่อบทบาทนี้มีอยู่ในระบบแล้ว',
  'Cannot delete or deactivate this item because it is in use': 'ไม่สามารถลบหรือปิดใช้งานรายการนี้ได้ เนื่องจากกำลังถูกใช้งานอยู่',
  'This role is created by the system, it cannot be deleted or deactivated': 'บทบาทนี้ระบบสร้างให้ ไม่สามารถลบหรือปิดใช้งานได้',
  'This role is created by the system, its name cannot be changed': 'บทบาทนี้ระบบสร้างให้ ไม่สามารถเปลี่ยนชื่อได้',
  'This role can only hold permissions of its own portal': 'บทบาทนี้กำหนดสิทธิ์ได้เฉพาะของพอร์ทัลตัวเองเท่านั้น',
  // ข้อมูลล้าสมัย
  'This work order was updated elsewhere, please reload and try again': 'ใบสั่งงานนี้ถูกแก้ไขจากที่อื่นแล้ว กรุณารีโหลดหน้าแล้วลองใหม่',
  'This goods issue was updated elsewhere, please reload and try again': 'ใบเบิกนี้ถูกแก้ไขจากที่อื่นแล้ว กรุณารีโหลดหน้าแล้วลองใหม่',
  // งานช่าง / visit
  'This visit is already closed, the service report cannot be submitted again': 'การเข้าพื้นที่นี้ปิดแล้ว ไม่สามารถส่งรายงานบริการซ้ำได้',
  'This job was started by another technician, you can only view it': 'งานนี้ช่างท่านอื่นเริ่มงานไปแล้ว คุณดูข้อมูลได้อย่างเดียว',
  'You are not assigned to this job': 'คุณไม่ได้รับมอบหมายงานนี้',
  'This visit has not been checked in yet, it cannot be checked out': 'ยังไม่ได้เช็คอิน จึงเช็คเอาท์ไม่ได้',
  'This visit has not been assigned to any technician yet': 'งานนี้ยังไม่ได้มอบหมายช่าง',
  'Cannot check out because there is a pending parts requisition (IAT) waiting for approval': 'เช็คเอาท์ไม่ได้ เพราะมีใบเบิกอะไหล่ (IAT) ที่รออนุมัติอยู่',
  'Cannot request parts for a visit that is already checked out or closed': 'เบิกอะไหล่ไม่ได้ เพราะงานนี้เช็คเอาท์หรือปิดไปแล้ว',
  'Cannot request additional parts until the previous requisition is approved': 'เบิกอะไหล่เพิ่มไม่ได้ จนกว่าใบเบิกรอบก่อนจะได้รับอนุมัติ',
  'Cannot cancel this work order because a visit has already started': 'ยกเลิกใบสั่งงานไม่ได้ เพราะมีการเริ่มงานไปแล้ว',
  'The visit can only be closed after the technician has closed the job (Close Job)': 'ปิดการเข้าพื้นที่ได้หลังจากช่างกดปิดงานแล้วเท่านั้น',
  'Please select the filter change result (success / failed) before closing the visit': 'กรุณาเลือกผลการเปลี่ยนไส้กรอง (สำเร็จ / ไม่สำเร็จ) ก่อนปิดงาน',
  'Invoice amount is 0 - only the Service Report is issued for this job': 'ยอดใบกำกับเป็น 0 งานนี้ออกเฉพาะใบรายงานบริการ',
  'visits_items must contain at least one item to reject': 'ต้องระบุรายการที่จะปฏิเสธอย่างน้อย 1 รายการ',
  // เลขไมล์ / เช็คอิน
  'Mileage for this date has already been recorded': 'วันนี้บันทึกเลขไมล์ไปแล้ว',
  'End mileage must be greater than or equal to start mileage': 'เลขไมล์สิ้นสุดต้องไม่น้อยกว่าเลขไมล์เริ่มต้น',
  'No vehicle registered for this technician, please contact the administrator to add a vehicle': 'ช่างยังไม่มีรถในระบบ กรุณาติดต่อผู้ดูแลระบบเพื่อเพิ่มรถ',
  'Selected vehicle not found or does not belong to this technician': 'ไม่พบรถที่เลือก หรือรถคันนี้ไม่ใช่ของช่างท่านนี้',
  'Mileage cannot be recorded for a future date': 'บันทึกเลขไมล์ล่วงหน้าไม่ได้',
  'Please attach at least one start mileage photo': 'กรุณาแนบรูปเลขไมล์เริ่มต้นอย่างน้อย 1 รูป',
  'Please attach at least one end mileage photo': 'กรุณาแนบรูปเลขไมล์สิ้นสุดอย่างน้อย 1 รูป',
  'Vehicle and companion technicians can only be set when checking in to an installation job': 'ระบุรถและช่างที่ไปด้วยได้เฉพาะตอนเช็คอินงานติดตั้ง',
  'Companion technicians must be assigned to the project of this work order': 'ช่างที่ไปด้วยต้องได้รับมอบหมายในโครงการของใบสั่งงานนี้',
  'You already have an open check-in in this project, please check out first': 'คุณเช็คอินในโครงการนี้ค้างอยู่ กรุณาเช็คเอาท์ก่อน',
  'Companion technicians who already have an open check-in in this project cannot be selected': 'เลือกช่างที่เช็คอินค้างอยู่ในโครงการนี้เป็นผู้ไปด้วยไม่ได้',
  'Companion technicians must be assigned to this phase (or to the project when the phase has no assigned technicians)': 'ช่างที่ไปด้วยต้องได้รับมอบหมายในงวดนี้ (หรือในโครงการ หากงวดนี้ไม่ได้กำหนดช่าง)',
  'Check-in without a plan is only available for installation projects': 'เช็คอินโดยไม่มีแผนได้เฉพาะโครงการติดตั้ง',
  'ช่างเช็คเอาท์จากงานนี้แล้ว ไม่สามารถเช็คเอาท์ซ้ำได้': 'ช่างเช็คเอาท์จากงานนี้แล้ว ไม่สามารถเช็คเอาท์ซ้ำได้',
  // เช็คลิสต์
  'Status must be one of draft, active, inactive': 'สถานะต้องเป็น ฉบับร่าง ใช้งาน หรือไม่ใช้งาน',
  'status must be active or inactive': 'สถานะต้องเป็นใช้งานหรือไม่ใช้งาน',
  'customer_status must be Active, Inactive or Hold': 'สถานะลูกค้าต้องเป็น ใช้งาน ไม่ใช้งาน หรือระงับ',
  'end_date must be on or after start_date': 'วันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่มต้น',
  'Only image or video files are allowed': 'แนบได้เฉพาะไฟล์รูปภาพหรือวิดีโอ',
  'Number can have at most 2 decimal places': 'ทศนิยมได้ไม่เกิน 2 ตำแหน่ง',
  'must be a valid date': 'รูปแบบวันที่ไม่ถูกต้อง',
  'name_th or name_en is required': 'กรุณากรอกชื่อภาษาไทยหรือภาษาอังกฤษอย่างน้อย 1 ช่อง',
  'Failed to register customer gateway': 'ลงทะเบียนช่องทางของลูกค้าไม่สำเร็จ',
  'Failed to register broker gateway': 'ลงทะเบียนช่องทางของนายหน้าไม่สำเร็จ',
};

// ชื่อ field ที่โผล่ในข้อความ {field} บ่อย (ไม่รู้จัก = แสดงตามเดิม)
const FIELD_TH = {
  email: 'อีเมล',
  password: 'รหัสผ่าน',
  company: 'บริษัท',
  user: 'ผู้ใช้',
  role: 'บทบาท',
  customer: 'ลูกค้า',
  name: 'ชื่อ',
  code: 'รหัส',
  data: 'ข้อมูล',
  asset: 'ทรัพย์สิน',
  project: 'โครงการ',
  'work order': 'ใบสั่งงาน',
  technician: 'ช่าง',
  part: 'อะไหล่',
  warehouse: 'คลัง',
};

// ข้อความที่มีตัวแปร {x} — ลำดับ: เฉพาะเจาะจงก่อน (กว้างอย่าง "{field} not found" ไว้ท้าย)
const PATTERN_TH = [
  ['Missing required field : {field}', 'กรุณากรอก {field}'],
  ['The field {field} is invalid', '{field} ไม่ถูกต้อง'],
  ['The field {field} must be an array', '{field} ต้องเป็นรายการ'],
  ['The field \'{field}\' must be a string with a maximum length of {max} characters', '{field} ต้องยาวไม่เกิน {max} ตัวอักษร'],
  ['The field \'{field}\' must be a numeric [0-9] value', '{field} ต้องเป็นตัวเลข 0-9 เท่านั้น'],
  ['This {field} already exists', '{field} นี้มีอยู่ในระบบแล้ว'],
  ['This {field} is already linked to {target}', '{field} นี้ถูกใช้งานร่วมกับ {target} อยู่'],
  ['This email is already used by user {user_code}', 'อีเมลนี้ถูกใช้โดยผู้ใช้ {user_code} แล้ว'],
  ['{field} is not available yet, please contact the administrator', '{field} ยังไม่พร้อมใช้งาน กรุณาติดต่อผู้ดูแลระบบ'],
  ['User limit reached for {module} ({used}/{max}), please contact the administrator to increase the limit', 'จำนวนผู้ใช้ของ {module} เต็มแล้ว ({used}/{max}) กรุณาติดต่อผู้ดูแลระบบเพื่อเพิ่มจำนวน'],
  ['This user type cannot sign in on {channel}', 'ผู้ใช้ประเภทนี้เข้าสู่ระบบทาง {channel} ไม่ได้'],
  ['Document type \'{field}\' is disabled for the selected category', 'ประเภทเอกสาร {field} ถูกปิดใช้งานในหมวดหมู่ที่เลือก'],
  ['Minimum amount is {amount} {currency}', 'ยอดขั้นต่ำคือ {amount} {currency}'],
  ['Maximum amount is {amount} {currency}', 'ยอดสูงสุดคือ {amount} {currency}'],
  ['Amount must be greater than {amount} {currency}', 'ยอดต้องมากกว่า {amount} {currency}'],
  ['Maximum {max} photos per mileage reading', 'แนบรูปเลขไมล์ได้สูงสุด {max} รูป'],
  ['Please record the end mileage of {date} before recording a later date', 'กรุณาบันทึกเลขไมล์สิ้นสุดของวันที่ {date} ก่อนบันทึกวันถัดไป'],
  ['Please answer all required checklist items before closing the job: {items}', 'กรุณาตอบรายการเช็คลิสต์ที่บังคับให้ครบก่อนปิดงาน: {items}'],
  ['Notification recipient has no email: {users}', 'ผู้รับแจ้งเตือนยังไม่มีอีเมล: {users}'],
  ['Text answer must not exceed {max} characters: {items}', 'คำตอบแบบข้อความต้องไม่เกิน {max} ตัวอักษร: {items}'],
  ['Unit is required for measurement and quantity items: {items}', 'กรุณาระบุหน่วยสำหรับรายการวัดค่าและจำนวน: {items}'],
  ['Min must not be greater than Max: {items}', 'ค่าต่ำสุดต้องไม่มากกว่าค่าสูงสุด: {items}'],
  ['Min/Max allow at most 2 decimal places: {items}', 'ค่าต่ำสุด/สูงสุดมีทศนิยมได้ไม่เกิน 2 ตำแหน่ง: {items}'],
  ['Invalid checklist section structure: {reason}', 'โครงสร้างหัวข้อเช็คลิสต์ไม่ถูกต้อง: {reason}'],
  ['{part}: requested {requested} exceeds available stock {available} ({source})', '{part}: ขอเบิก {requested} เกินจำนวนคงเหลือ {available} ({source})'],
  ['Part {part} of pending IAT {iat} has no lot selected', 'อะไหล่ {part} ของ IAT {iat} ที่รออนุมัติ ยังไม่ได้เลือก Lot'],
  ['Pending IAT {iat} must keep at least 1 part', 'IAT {iat} ที่รออนุมัติ ต้องเหลืออะไหล่อย่างน้อย 1 รายการ'],
  ['Part {part} of pending IAT {iat} must stay in warehouse {warehouse}', 'อะไหล่ {part} ของ IAT {iat} ที่รออนุมัติ ต้องอยู่คลัง {warehouse} เดิม'],
  ['This visit already reached the maximum of {max} parts requisition rounds', 'งานนี้เบิกอะไหล่ครบสูงสุด {max} รอบแล้ว'],
  ['IAT {iat} of visit {sequence} has already been approved and issued, it cannot be updated', 'IAT {iat} ของการเข้าพื้นที่ {sequence} อนุมัติและเบิกของไปแล้ว แก้ไขไม่ได้'],
  ['IAT {iat} of visit {sequence} has no pending goods issue to reject', 'IAT {iat} ของการเข้าพื้นที่ {sequence} ไม่มีใบเบิกที่รออนุมัติให้ปฏิเสธ'],
  ['{field} not found', 'ไม่พบ {field} ในระบบ'],
];

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// คอมไพล์ pattern เป็น RegExp ครั้งเดียว: {x} -> (.+?) แล้วจำลำดับชื่อตัวแปรไว้แทนค่าคืน
const COMPILED = PATTERN_TH.map(([en, thText]) => {
  const names = [];
  const source = escapeRe(en).replace(/\\\{(\w+)\\\}/g, (_, name) => {
    names.push(name);
    return '(.+?)';
  });
  return { re: new RegExp(`^${source}$`, 's'), names, th: thText };
});

const translateField = (value) => FIELD_TH[String(value).trim().toLowerCase()] || value;

/**
 * แปลข้อความจาก backend ตามภาษาปัจจุบัน (EN หรือไม่รู้จัก = คืนค่าเดิม)
 * @param {*} message
 * @returns {*}
 */
export const translateMessage = (message) => {
  if (typeof message !== 'string' || !message.trim() || currentLang() === 'EN') return message;
  const text = message.trim();
  if (MESSAGE_TH[text]) return MESSAGE_TH[text];
  for (const { re, names, th: thText } of COMPILED) {
    const match = re.exec(text);
    if (!match) continue;
    return thText.replace(/\{(\w+)\}/g, (_, name) => {
      const idx = names.indexOf(name);
      if (idx < 0) return `{${name}}`;
      const value = match[idx + 1];
      return name === 'field' ? translateField(value) : value;
    });
  }
  return message;
};

// หัวข้อ alert ที่ hardcode เป็นอังกฤษ ('Warning' / 'Success' / 'Error') -> ตามภาษา
const TITLE_KEY = { warning: 'warning', success: 'success', error: 'error' };

export const translateTitle = (title) => {
  const key = typeof title === 'string' ? TITLE_KEY[title.trim().toLowerCase()] : null;
  return key ? uiText(key) : title;
};
